import React, {ReactElement} from "react";

import JTBDCard from "../cards/jtbd-card/JTBDCard";
import {ImageObject} from "../image/Image";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./jtbd-collection.module.scss";

export interface JTBDCollectionProps
  extends Pick<Queries.JtbdCollectionFragmentFragment, "cards" | "layout"> {
  classes?: string;
}

const JTBDCollection = (props: JTBDCollectionProps): ReactElement => {
  const {cards, layout, classes} = props;

  return (
    <ul
      className={css(
        styles.jtbdCollection,
        styles[`jtbdCollection${layout || "1"}`],
        classes!
      )}
    >
      {cards &&
        cards.map((card, i) => {
          const keyValue = [
            card?.body?.body!,
            card?.eyebrow!,
            card?.headline!,
          ].join("-");
          const key = `jtbd-collection-item-${keyValue}-${i}`;

          return (
            <li
              key={generateKeyId(key)}
              className={styles.jtbdCollection__item}
            >
              <JTBDCard
                body={card?.body?.body!}
                url={card?.ctaUrl!}
                eyebrow={card?.eyebrow!}
                headline={card?.headline!}
                image={card?.image as ImageObject}
                classes={css(
                  styles.jtbdCollection__card,
                  styles[`jtbdCollection__card${i + 1}`],
                  i === cards.length - 1 ? styles.jtbdCollection__cardLast : ""
                )}
              />
            </li>
          );
        })}
    </ul>
  );
};

export default JTBDCollection;
